export default __webpack_public_path__ + "static/media/infoIcon.0ef79029.svg";